import * as index_html from './index.html'

export default [index_html]
